var newsList = {
	noResults: "Nessun risultato trovato",
	readMore: "Leggi tutto",
	estimatedReadingTime: "~{minutes} min di lettura"
};
var it = {
	newsList: newsList
};

export { it as default, newsList };
